import React, { Component } from "react";
import { Link } from "react-router-dom";

import colors from "../../../values/colors";
import urls from "../../../values/urls";

/**
 * Pulsante (a livello sensore) che apre la dashboard Grafana del sensore in una
 * pagina dedicata (`/training/sensors/{id}/dashboard`), da cui si torna al
 * dettaglio sensore. Viene mostrato solo se `dashboardUrl` è valorizzato nello
 * status JSON del sensore (campo `last_status.dashboard_url`). La pagina di
 * destinazione carica l'iframe verso il reverse proxy per-sensore di
 * centroservizi (vedi sensor/grafana_proxy.py).
 */
class DashboardButton extends Component {
  render() {
    const { dashboardUrl, idSensor } = this.props;
    if (!dashboardUrl || !idSensor) return null;

    const to = `${urls.DASHBOARD_BASE}/sensors/${idSensor}/dashboard`;

    return (
      <Link to={to} title="Dashboard" style={_style.wrapper}>
        <div className="command" style={_style.circle}>
          <span
            className="material-symbols-outlined dashboard-cmd-icon"
            style={{ color: "white" }}
          >
            monitoring
          </span>
        </div>
      </Link>
    );
  }
}

export default DashboardButton;

const _style = {
  wrapper: {
    display: "inline-block",
    borderRadius: 37,
    border: "none",
    padding: 0,
    backgroundColor: "#fff",
    boxShadow: "0 0 0 1.5px #fff",
    cursor: "pointer",
    // evita l'underline blu di Bootstrap (a:hover) — è un <a> via <Link>
    textDecoration: "none",
  },
  circle: {
    overflow: "hidden",
    borderRadius: "100%",
    margin: 0,
    transitionDuration: "0.2s",
    backgroundColor: colors.secondary,
    cursor: "pointer",
    MozBoxShadow: "inset 7px 0 10px rgba(0,0,0,.3)",
    WebkitBoxShadow: "inset 7px 0 10px rgba(0,0,0,.3)",
    boxShadow: "inset 7px 0 10px rgba(0,0,0,.3)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
};
